import moment from 'moment'
import request from '../../../../setup/axios/request'
import requestLogin from '../../../../setup/axios/request-login'

export interface Lang {
  selectedLang: 'en' | 'vi'
}

interface LoginModel {
  model: {
    userNameOrEmail: string
    password: string
    remember: boolean
    languageCode?: string
  }
}

interface VerifyEmail {
  model: {
    userId: string
    code: string
  }
}

interface ChangePassword {
  model: {
    userId: string
    oldPassword: string
    newPassword: string
    confirmPassword: string
  }
}

interface ResetPassword {
  model: {
    userId: string
    newPassword: string
    confirmPassword: string
  }
}

interface PinCode {
  model: {
    code: string
    userId: string
    email: string
  }
}

interface Email {
  model: {
    email: string
  }
}

interface GoogleAuth {
  model: {
    userId: string
    code: string
    sharedKey: string
    authenticatorUri: boolean
  }
}

interface TwoFactorAuth {
  model: {
    applicationType: number
    userId: string
    sesssionId: string
    authenticationType: string
    code: string
    remember: boolean
    languageCode?: string
  }
}

const lang = localStorage.getItem('i18nConfig')
const lang_r = lang ? JSON.parse(lang).selectedLang : 'VI'

export const login = (data: LoginModel) => {
  data.model.languageCode = lang_r.toUpperCase()
  return requestLogin({
    url: '/api/v1/Identity/login',
    method: 'post',
    data: data,
  })
}

export const getPermissionByUserid = (userId: string) => {
  return request({
    url: '/api/v1/Identity/get-permission-by-userid/' + userId,
    method: 'get',
  })
}

export const refreshToken = (data: any) => {
  return request({
    url: '/api/v1/Identity/refresh-token',
    method: 'post',
    data: data,
  })
}

export const revokeRefreshToken = (data: any) => {
  return request({
    url: '/api/v1/Identity/revoke-refresh-token',
    method: 'post',
    data: data,
  })
}

export const getListViewByUserID = (userId: string) => {
  return request({
    url: '/api/v1/IdentityCms/get-all-data-view-permission-by-user/' + userId,
    method: 'get',
  })
}

export const getCommonCode = (lang: string) => {
  return request({
    url: '/api/v1/Pricing/get-list-common-code?languageCode=' + lang.toUpperCase(),
    method: 'get',
  })
}

export const searchAndPagingCountry = () => {
  let data = {
    filter: {
      searchField: '',
      code: '',
      name: '',
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    pageIndex: 0,
    pageSize: -1,
    showTotal: true,
  }

  return request({
    url: '/api/v1/Configuration/country/search-and-pagging',
    method: 'post',
    data: data,
  })
}

export const verifyEmail = (data: VerifyEmail) => {
  return request({
    url: '/api/v1/Identity/verify-email',
    method: 'post',
    data: data,
  })
}

export const changePassword = (data: ChangePassword) => {
  return requestLogin({
    url: '/api/v1/Identity/change-password-selling',
    method: 'post',
    data: data,
  })
}

export const resetPassword = (data: ResetPassword) => {
  return request({
    url: '/api/v1/Identity/reset-password-by-userid',
    method: 'post',
    data: data,
  })
}

export const createPinCode = (data: PinCode) => {
  return request({
    url: '/api/v1/Identity/create-pin-code',
    method: 'post',
    data: data,
  })
}

export const loginCmsStep2 = (data: TwoFactorAuth) => {
  data.model.languageCode = lang_r.toUpperCase()
  return requestLogin({
    url: '/api/v1/Identity/login-cms-step2',
    method: 'post',
    data: data,
  })
}

export const sendEmailResetPass = (data: Email) => {
  return request({
    url: '/api/v1/Identity/send-email-reset-password',
    method: 'post',
    data: data,
  })
}

export const sendEmailAuthenCode = (data: Email) => {
  return request({
    url: '/api/v1/Identity/send-email-authen-code',
    method: 'post',
    data: data,
  })
}

export const enableAuthenticator = (userId: string) => {
  return request({
    url: '/api/v1/Identity/enable-authenticator/' + userId,
    method: 'get',
  })
}

export const enableAuthenticatorPost = (data: GoogleAuth) => {
  return request({
    url: '/api/v1/Identity/enable-authenticator',
    method: 'post',
    data: data,
  })
}

export const getListSellingNotification = (userId: string, unRead?: boolean) => {
  let data: any = {
    includes: [],
    filters: [
      {
        fieldName: 'UserReceive',
        comparision: '==',
        fieldValue: userId,
      },
    ],
    sorts: [{FieldName: 'SendingTime', SortType: '1'}],
    page: 1,
    pageSize: 100,
    id: null,
    isPagingEnabled: true,
  }

  if(unRead) {
    data.filters.push({
      fieldName: 'IsRead',
        comparision: '==',
        fieldValue: false,
    })
  }

  return request({
    url: '/api/v1/Notification/get-selling-notifications',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(data),
    },
  })
}

export const updateSellingNotification = (id: string) => {
  return request({
    url: '/api/v1/Notification/update-selling-notification/' + id,
    method: 'put',
    data: {
      receiveTime: moment(new Date()),
      isRead: true,
    },
  })
}
